var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeachersicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_198)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3.75H24.125V6.875H22.875V5H6V19.375H19.3669V20.625H4.75V3.75ZM23.5 11.875C23.9973 11.875 24.4742 11.6775 24.8258 11.3258C25.1775 10.9742 25.375 10.4973 25.375 10C25.375 9.50272 25.1775 9.02581 24.8258 8.67417C24.4742 8.32254 23.9973 8.125 23.5 8.125C23.0027 8.125 22.5258 8.32254 22.1742 8.67417C21.8225 9.02581 21.625 9.50272 21.625 10C21.625 10.4973 21.8225 10.9742 22.1742 11.3258C22.5258 11.6775 23.0027 11.875 23.5 11.875ZM24.7694 13.1313C25.5812 13.1313 26.2237 13.4963 26.6444 14.06C27.0375 14.5881 27.2037 15.2413 27.2412 15.8444C27.278 16.4631 27.1937 17.083 26.9931 17.6694C26.8056 18.2131 26.4887 18.7756 26 19.1613V25.3125C26.0005 25.548 25.9122 25.7751 25.7529 25.9486C25.5935 26.122 25.3747 26.2291 25.1399 26.2486C24.9052 26.2681 24.6717 26.1984 24.486 26.0536C24.3002 25.9087 24.1758 25.6993 24.1375 25.4669L23.3312 20.625H23.145L22.2337 25.485C22.1905 25.7144 22.0632 25.9194 21.8768 26.0599C21.6904 26.2004 21.4583 26.2663 21.2259 26.2447C20.9934 26.2231 20.7774 26.1156 20.6201 25.9432C20.4627 25.7708 20.3753 25.5459 20.375 25.3125V16.3956C20.25 16.586 20.1267 16.7775 20.005 16.97L19.9562 17.0469L19.9437 17.0669L19.9406 17.0725C19.8564 17.2077 19.7391 17.3193 19.5998 17.3966C19.4604 17.4739 19.3037 17.5145 19.1444 17.5144H16.0194C15.7707 17.5144 15.5323 17.4156 15.3565 17.2398C15.1806 17.064 15.0819 16.8255 15.0819 16.5769C15.0819 16.3282 15.1806 16.0898 15.3565 15.914C15.5323 15.7381 15.7707 15.6394 16.0194 15.6394H18.63C18.7819 15.4044 18.9819 15.0994 19.1919 14.7931C19.4106 14.4738 19.6519 14.1356 19.8669 13.8706C19.9712 13.7413 20.0881 13.6062 20.2056 13.4956C20.2631 13.4412 20.3431 13.3706 20.4406 13.3081C20.6127 13.1952 20.8136 13.134 21.0194 13.1319H24.7694V13.1313Z",
    fill: "#311A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_198",
    x: -3,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_198",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachersicon);
export default __webpack_public_path__ + "static/media/teachersicon.de75674d6c4612a9f26d878feef415a5.svg";
export { ForwardRef as ReactComponent };